module.exports = __webpack_public_path__ + "static/chai-f25baaffb7ff188fef9a2ad6b2eee6f4.jpg";